export const ERROR_API_VERSION = 1001;
export function format(code, message) {
    return `E${code}: ${message}`;
}
export function parseCode(error) {
    // Expected format: "E12345: Error message"
    if (!error) {
        return 0; // empty string
    }
    if (error[0] != 'E') {
        return 0;
    }
    for (let i = 1; i < error.length; ++i) {
        const c = error[i];
        if (c < '0' || c > '9') {
            return 0;
        }
        if (c === ':') {
            return parseInt(error.substring(1, i), 10) || 0;
        }
    }
    return 0;
}
export function errorToString(error) {
    if (error instanceof Error) {
        return error.stack || error.message || error.toString();
    }
    return String(error); // Fallback for non-Error types
}
//# sourceMappingURL=ErrorUtils.js.map